import {useState} from "react";
import AnalyticsService from "../services/api/analytics";

const useAnalytics = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [total_verification_group_by_status, setTotalVerificationGroupByStatus] = useState([]);
    const [total_authentication, setTotalAuthentication] = useState(null);
    const [top_product_auth_vs_verification, setTopProductAuthVsVerification] = useState([]);
    const [top_product_auth_vs_verification_lat_long, setTopProductAuthVsVerificationLatLong] = useState(null);
    const [top_verified_products, setTopVerifiedProducts] = useState([]);
    const [verification_per_hour, setVerificationPerHour] = useState(null);
    const [verification_per_month, setVerificationPerMonth] = useState([]);
    const [isFetchingProductView, setFetchingProductView] = useState(false);
    const [productViewDetails, setProductViewDetails] = useState(null);

    const [isLoadingTopProductVsVerification, setLoadingTopProductVsVerification] = useState(false);
    const [isLoadingTopVerifiedProduct, setLoadingTopVerifiedProduct] = useState(false);
    const [isFetchVerificationPerMonth, setFetchVerificationPerMonth] = useState(false);

    const getTotalVerificationGroupByStatus = () => {
        setLoading(true);
        AnalyticsService.getTotalVerificationGroupByStatus().then((res)=>{
            setLoading(false);
            if (!res.data.success) setError(res.data.error);
            setTotalVerificationGroupByStatus(res.data.data);
        }).catch((error)=>{
            setLoading(false);
            setError(error);
        });
    }

    const getTotalAuthentication = () => {
        setLoading(true);
        AnalyticsService.getTotalAuthentication().then((res)=>{
            setLoading(false);
            if (!res.data.success) setError(res.data.error);
            var data = res.data.data;
            var total_count = data.product + data.document;
            setTotalAuthentication(total_count);
        }).catch((error)=>{
            setLoading(false);
            setError(error);
        });
    }

    const getTopProductAuthVsVerification = (country, region) => {
        setLoadingTopProductVsVerification(true);
        AnalyticsService.getTopProductAuthVsVerification(country, region).then((res)=>{
            setLoadingTopProductVsVerification(false);
            if (!res.data.success) setError(res.data.error);
            setTopProductAuthVsVerification(res.data.data);
        }).catch((error)=>{
            setLoadingTopProductVsVerification(false);
            setError(error);
        });
    }

    const getTopProductAuthVsVerificationLatLong = (country, region) => {
        setLoading(true);
        AnalyticsService.getTopProductAuthVsVerificationLatLong(country, region).then((res)=>{
            setLoading(false);
            if (!res.data.success) setError(res.data.error);
            setTopProductAuthVsVerificationLatLong(res.data.data);
        }).catch((error)=>{
            setLoading(false);
            setError(error);
        });
    }

    const getTopVerifiedProducts = (country, region) => {
        setLoadingTopVerifiedProduct(true);
        AnalyticsService.getTopVerifiedProducts(country, region).then((res)=>{
            setLoadingTopVerifiedProduct(false);
            if (!res.data.success) setError(res.data.error);
            setTopVerifiedProducts(res.data.data);
        }).catch((error)=>{
            setLoadingTopVerifiedProduct(false);
            setError(error);
        });
    }

    const getVerificationPerHour = () => {
        setLoading(true);
        AnalyticsService.getVerificationPerHour().then((res)=>{
            setLoading(false);
            if (!res.data.success) setError(res.data.error);
            setVerificationPerHour(res.data.data);
        }).catch((error)=>{
            setLoading(false);
            setError(error);
        });
    }

    const getVerificationPerMonth = (year, product_code) => {
        setFetchVerificationPerMonth(true);
        AnalyticsService.getVerificationPerMonth(year, product_code).then((res)=>{
            setFetchVerificationPerMonth(false);

            if (!res.data.success) setError(res.data.error);
            setVerificationPerMonth(res.data.data);
        }).catch((error)=>{
            setFetchVerificationPerMonth(false);
            setError(error);
        });
    }

    const getTopProductAuthenticationDetailView = (product_code) => {
        setFetchingProductView(true);

        AnalyticsService.getTopProductAuthenticationDetailView(product_code).then((res) => {
            console.log("getTopProductAuthenticationDetailView data xxxx", res.data);
            
            if (res.data.success) {
                setFetchingProductView(false);
                setProductViewDetails(res.data.data);
            }

        }).catch((error) => {
            console.log("getTopProductAuthenticationDetailView error xxxx", error);

            setFetchingProductView(false);
        })
    }

    
    return { 
        loading, error, 
        total_verification_group_by_status, getTotalVerificationGroupByStatus, 
        total_authentication, getTotalAuthentication, 
        top_product_auth_vs_verification, getTopProductAuthVsVerification, 
        top_product_auth_vs_verification_lat_long, getTopProductAuthVsVerificationLatLong, 
        top_verified_products, getTopVerifiedProducts, 
        verification_per_hour, getVerificationPerHour,
        verification_per_month, getVerificationPerMonth,
        isFetchingProductView, productViewDetails, getTopProductAuthenticationDetailView,
        isLoadingTopProductVsVerification, isLoadingTopVerifiedProduct, isFetchVerificationPerMonth
    }
    
}

export default useAnalytics;